import classNames from 'classnames';
import * as React from 'react';
import Button from '../Button/Button.js';
import styles from './ButtonIcon.module.scss.js';

var ButtonIcon = function (props) {
    var renderIcon = function () {
        switch (props.type) {
            case 'info': {
                return React.createElement("div", { className: styles.infoIcon });
            }
            case 'clan-info': {
                return React.createElement("div", { className: styles.clanInfoIcon });
            }
            case 'check': {
                return React.createElement("div", { className: styles.checkIcon });
            }
            case 'cross': {
                return React.createElement("div", { className: styles.crossIcon });
            }
            case 'plus': {
                return React.createElement("div", { className: styles.plusIcon });
            }
            default: {
                return React.createElement("div", { className: styles.icon });
            }
        }
    };
    return (React.createElement(Button, { isIcon: true, isFlat: props.isFlat, isDisabled: props.isDisabled, tooltipContent: props.tooltipContent, type: props.buttonType, onClick: props.onClick, className: classNames(props.className) }, renderIcon()));
};
var ButtonIcon$1 = React.memo(ButtonIcon);

export { ButtonIcon$1 as default };
//# sourceMappingURL=ButtonIcon.js.map
